import React, { useState, useEffect, useRef, useMemo } from "react";
import { Form, Input, Button, Modal, Space, message } from "antd";
import { lib, MultipleUploader } from "react-single-app";
import "./email-audit.css";

const ShowImage = React.memo(({ url }) => {
    return (
        <div style={{ display: "flex", lineHeight: "20px" }}>
            {url && (
                <>
                    <h2>残次图片详情链接:</h2>
                    <a href={url} style={{ fontSize: "16px" }} target="_blank">
                        {url}
                    </a>
                </>
            )}
        </div>
    );
});
const RenderAnnex = React.memo(({ filePath, fileType }) => {
    if (filePath && fileType == "pdf") {
        return <iframe width={"100%"} height={700} src={filePath}></iframe>;
    }
    if (filePath && ["xls", "xlsx", "doc", "docx", "ppt", "pptx"].includes(fileType)) {
        return (
            <iframe
                src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                    filePath,
                )}`}
                width="100%"
                height="700px"
                frameBorder="1"
            />
        );
    }
    return (
        <div style={{ width: "100%", height: 700, display: "flex", justifyContent: "center" }}>
            <div style={{ textAlign: "center" }}>
                <a target="_blank" href={filePath}>
                    {filePath}
                </a>
            </div>
        </div>
    );
});
const UpLoadFile = React.memo(({ visible, setVisible, refresh, row }) => {
    const tallyOrderNo = lib.getParam("tallyOrderNo");
    const tenantId = lib.getParam("tenantId");
    const [form] = Form.useForm();
    const formLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
    };

    useEffect(() => {
        if (visible && row.draftAttachmentFile) {
            form.setFieldsValue({
                draftAttachmentFile: row.draftAttachmentFile,
            });
        }
    }, [visible]);

    const onOk = () => {
        form.validateFields().then(values => {
            lib.request({
                url: "/ares-web/tallyReport/addDraftAttachmentFile",
                data: {
                    draftAttachmentFile: values.draftAttachmentFile,
                    tallyOrderNo: tallyOrderNo,
                    tenantId: tenantId ? Number(tenantId) : null,
                },
                needMask: true,
                success: _ => {
                    refresh();
                    setVisible(false);
                },
            });
        });
        // const values = await form.validateFields();
        // lib.request({
        //     url: "/ares-web/tallyReport/addDraftAttachmentFile",
        //     data: {
        //         draftAttachmentFile: values.draftAttachmentFile,
        //         tallyOrderNo: tallyOrderNo,
        //         tenantId: tenantId ? Number(tenantId) : null,
        //     },
        //     needMask: true,
        //     success: _ => {
        //         refresh();
        //         setVisible(false);
        //     },
        // });
    };
    return (
        <Modal
            title="上传草单"
            visible={visible}
            onOk={onOk}
            onCancel={() => setVisible(false)}
            destroyOnClose={true}>
            <Form form={form} {...formLayout}>
                <Form.Item label="附件" name="draftAttachmentFile" extra={"可上传pdf、word、excel"}>
                    <MultipleUploader
                        disabled={row?.draftAttachmentFile}
                        allowTypes={[".pdf", ".doc", ".docx", ".xls", ".xlsx"]}
                        maxCount={1}
                        onChange={fileList => {
                            fileList.map(item => (item.key = item.url));
                            form.setFieldsValue({ draftAttachmentFile: fileList });
                        }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
});

function EmailAudit() {
    const sign = lib.getParam("sign"),
        tallyOrderNo = lib.getParam("tallyOrderNo"),
        tenantId = lib.getParam("tenantId"),
        inputRef = useRef(null),
        [filePath, setFilePath] = useState(null),
        [fileType, setfileType] = useState(null),
        [emailStatus, setEmailStatus] = useState(null),
        [ImagePath, setImagePath] = useState(null),
        [visible, setVisible] = useState(false),
        [isPassed, setIsPassed] = useState(null),
        [loaderVisible, setLoaderVisible] = useState(false),
        [detail, setDetail] = useState({}),
        [verificationCode, setVerificationCode] = useState(""),
        [messageData, setMessageData] = useState("");
    useEffect(() => {
        getDetail();
    }, []);

    const getExtension = name => {
        let lastName = name.substring(name.lastIndexOf(".") + 1);
        return lastName;
    };

    const getDetail = () => {
        lib.request({
            url: "/ares-web/tallyReport/signGetDetail",
            data: {
                tallyOrderNo,
                sign,
                tenantId: tenantId ? Number(tenantId) : null,
            },
            success: res => {
                try {
                    let page = res?.attachmentCompressFile[0]?.key;
                    setImagePath(page);
                } catch (error) {
                    console.log(error);
                }
                let file = res?.attachmentFile[0]?.key;
                setDetail(res);
                setFilePath(file);
                setfileType(getExtension(file));
            },
        });
    };

    const handleEmail = boolean => {
        lib.request({
            url: boolean
                ? "/ares-web/tallyReport/signApprovalSuccess"
                : "/ares-web/tallyReport/signApprovalFail",
            needMask: true,
            data: {
                sign,
                tallyOrderNo,
                tenantId: tenantId ? Number(tenantId) : null,
                message: messageData,
                verificationCode,
            },
            success: res => {
                message.success("操作成功");
                setVisible(false);
                setEmailStatus(1);
                setMessageData("");
            },
        });
    };

    const handleButton = boolean => {
        if (!verificationCode) {
            return message.error("请输入审核码");
        }
        setVisible(true);
        setIsPassed(boolean);
    };

    const renderText = res => {
        if (res.tallyType == "CK") {
            return {
                PAGE: (
                    <div style={{ fontSize: "16px" }}>
                        <p>
                            仓内必须完全依据打托明细报告出库，<strong>请关注【正残和效期】</strong>
                        </p>
                        <p>
                            如果是区间转仓，请点击
                            <a
                                style={{ color: "red", textDecorationLine: "underline" }}
                                onClick={() => {
                                    setLoaderVisible(true);
                                }}>
                                上传草单附件
                            </a>
                        </p>
                    </div>
                ),
                DETAIL: (
                    <div>
                        <p>
                            仓内必须<strong>完全依据理货报告出库，请关注【正残和效期】。</strong>
                        </p>
                        <p>再次确认，无需修改报告：</p>
                    </div>
                ),
            };
        }
        return {
            PAGE: (
                <div style={{ fontSize: "16px" }}>
                    <p>
                        仓内必须
                        <span style={{ color: "red" }}>
                            完全依据理货报告收货，请关注【正残和效期】
                        </span>
                    </p>
                    <p>
                        以下特殊情况，请<span style={{ color: "red" }}>驳回并告知</span>重新理货：
                    </p>
                    <p>1.需要【残次转为正品】收货</p>
                    <p>2.实物需要解码【回复告知效期】</p>
                </div>
            ),
            DETAIL: (
                <div>
                    <p>
                        仓内必须<strong>完全依据理货报告收货，请关注【正残和效期】。</strong>
                    </p>
                    <p>再次确认，无需修改报告：</p>
                    <h2 style={{ color: "red" }}>不需要残次转良品、 解码修改效期</h2>
                    <p>若需修改效期、残品转良；请点击【驳回，重新理货】</p>
                </div>
            ),
        };
    };
    const secondaryConfirm = useMemo(() => {
        const onCancel = () => {
            setMessageData("");
            setVisible(false);
        };

        return (
            <Modal
                title="二次确认报告"
                visible={visible}
                width={700}
                onCancel={() => {
                    setMessageData("");
                    setVisible(false);
                }}
                footer={
                    <Space>
                        <Button onClick={() => handleEmail(isPassed)} type="primary">
                            {isPassed ? "确认报告" : "驳回，重新理货"}
                        </Button>
                        <Button onClick={onCancel}>取消</Button>
                    </Space>
                }>
                {isPassed && renderText(detail)?.DETAIL}
                <Form.Item label="备注">
                    <Input.TextArea
                        value={messageData}
                        onChange={e => setMessageData(e.target.value)}></Input.TextArea>
                </Form.Item>
            </Modal>
        );
    }, [visible, isPassed, detail, messageData]);

    return (
        <div>
            <RenderAnnex filePath={filePath} fileType={fileType} />
            <ShowImage url={ImagePath} />
            {secondaryConfirm}
            <UpLoadFile
                visible={loaderVisible}
                setVisible={e => setLoaderVisible(e)}
                refresh={getDetail}
                row={detail}
            />
            {emailStatus === null ? (
                <>
                    {renderText(detail)?.PAGE}
                    <div>
                        <div className="audit-code">
                            <label className="audit-code-label">审核码:</label>
                            <Input
                                style={{ width: "200px" }}
                                value={verificationCode}
                                onChange={e => {
                                    //去除空格
                                    let value = e.target.value.replace(/\s+/g, "");
                                    setVerificationCode(value);
                                }}
                            />
                        </div>
                        <Space className="audit-button">
                            <Button
                                type="primary"
                                onClick={() => {
                                    handleButton(true);
                                }}>
                                确认报告
                            </Button>
                            <Button onClick={() => handleButton(false)}>驳回，重新理货</Button>
                        </Space>
                    </div>
                </>
            ) : (
                <h1 style={{ margin: "35px 0px" }}>操作成功，邮件已回复</h1>
            )}
        </div>
    );
}
export default EmailAudit;
